(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const syncAnnouncementBarHeight = () => {
      document.documentElement.style.setProperty('--announcement-bar-height', announcementBar.getBoundingClientRect().height + 'px');
    };
    syncAnnouncementBarHeight();
    if (window.dpdAnnouncementResizeObserver) window.dpdAnnouncementResizeObserver.disconnect();
    window.dpdAnnouncementResizeObserver = new ResizeObserver(syncAnnouncementBarHeight);
    window.dpdAnnouncementResizeObserver.observe(announcementBar);
  } else {
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  if (window.__dpdDrawer) return;
  window.__dpdDrawer = 1;
  let last = null, productId = null, busy = false, stale = false;
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const root = () => window.Shopify?.routes?.root || '/';
  const copy = key => drawer()?.dataset[key] || '';
  const sync = () => {
    const x = drawer(); if (!x) return;
    x.dataset.loading = String(busy);
    x.querySelector('.dpd-drawer__panel')?.setAttribute('aria-busy', String(busy));
    x.querySelectorAll('[data-line], [name="checkout"]').forEach(b => b.disabled = busy || stale);
    const reload = x.querySelector('[data-cart-reload]'); if (reload) reload.disabled = busy;
    const recovery = x.querySelector('[data-cart-recovery]'); if (recovery) recovery.hidden = !stale;
  };
  const message = text => {
    const p = drawer()?.querySelector('[data-drawer-status]');
    if (p) { p.textContent = text; p.hidden = !text; }
  };
  const open = () => {
    const x = drawer(); if (!x) return;
    x.dataset.open = 'true'; x.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dpd-cart-open');
  };
  const close = () => {
    const x = drawer(); if (!x) return;
    x.dataset.open = 'false'; x.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dpd-cart-open'); last?.focus(); last = null;
  };
  const count = () => {
    const x = drawer(), a = document.querySelector('.header-action--cart'); if (!x || !a) return;
    let badge = a.querySelector('.cart-count');
    if (+x.dataset.count) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; badge.setAttribute('aria-hidden','true'); a.append(badge); }
      badge.textContent = x.dataset.count;
    } else badge?.remove();
  };
  const apply = html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('#shopify-section-cart-drawer'), current = document.querySelector('#shopify-section-cart-drawer');
    const nd = next?.querySelector('[data-cart-drawer]');
    if (!current || !nd) throw new Error('Invalid cart section');
    const isOpen = drawer()?.dataset.open === 'true';
    nd.dataset.open = String(isOpen); nd.setAttribute('aria-hidden', String(!isOpen));
    current.replaceWith(next); stale = false; sync(); count();
  };
  const refresh = async () => {
    const res = await fetch(root() + '?section_id=cart-drawer', { headers: { 'X-Requested-With':'XMLHttpRequest' }, cache:'no-store' });
    if (!res.ok) throw new Error('Cart read failed');
    apply(await res.text());
  };
  const recs = async (id, intent = 'complementary') => {
    const x = drawer(), slot = x?.querySelector('[data-recs-slot]'); if (!slot || !id) return;
    try {
      const res = await fetch(`${x.dataset.recs}?section_id=cart-drawer-recommendations&product_id=${encodeURIComponent(id)}&limit=3&intent=${intent}`);
      if (!res.ok) return;
      const r = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('.dpd-recs');
      if (!slot.isConnected) return;
      if (r) slot.replaceChildren(r); else if (intent === 'complementary') await recs(id, 'related');
    } catch {}
  };
  const write = async (url, options, successKey) => {
    let confirmed = false;
    try {
      const response = await fetch(url, options);
      confirmed = response.ok;
      const payload = await response.json().catch(() => null);
      if (!response.ok) {
        const detail = payload?.description || payload?.message;
        const text = typeof detail === 'string' ? detail : copy('error');
        try { await refresh(); } catch { stale = true; }
        message(text); return;
      }
      productId = payload?.product_id || payload?.items?.[0]?.product_id || productId;
      const html = payload?.sections?.['cart-drawer'];
      try { if (!html) throw new Error('Missing section'); apply(html); }
      catch { await refresh(); }
      message(copy(successKey));
      productId = productId || drawer()?.dataset.productId;
      void recs(productId);
    } catch {
      stale = true;
      message(copy(confirmed ? 'refreshError' : 'uncertain'));
    } finally { busy = false; sync(); }
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || !drawer()) return;
    event.preventDefault();
    if (busy) return;
    if (stale) { open(); sync(); return; }
    busy = true;
    const button = event.submitter, wasDisabled = button?.disabled;
    const data = new FormData(form);
    data.delete('return_to'); data.set('sections', 'cart-drawer'); data.set('sections_url', location.pathname);
    if (button) button.disabled = true;
    if (drawer().dataset.open !== 'true') last = button || document.activeElement;
    open(); message(''); sync();
    const url = new URL(form.action); if (!url.pathname.endsWith('.js')) url.pathname += '.js';
    try { await write(url.href, { method:'POST', body:data, headers:{Accept:'application/json'} }, 'added'); }
    finally { if (button) button.disabled = wasDisabled; }
  });
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-drawer-close]')) { event.preventDefault(); close(); return; }
    const quantity = event.target.closest('[data-line][data-qty]');
    if (quantity && drawer()?.contains(quantity)) {
      event.preventDefault(); if (busy || stale) return;
      busy = true; message(''); sync();
      await write(drawer().dataset.change, { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:quantity.dataset.line,quantity:Number(quantity.dataset.qty),sections:'cart-drawer',sections_url:location.pathname}) }, 'updated');
      return;
    }
    const link = event.target.closest('.header-action--cart');
    const reload = event.target.closest('[data-cart-reload]');
    if (!reload && !(link && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey)) return;
    if (!drawer()) return;
    event.preventDefault(); if (link) last = link;
    open(); if (busy) return;
    busy = true; message(''); sync();
    try { await refresh(); void recs(productId || drawer()?.dataset.productId); }
    catch { stale = true; message(copy('uncertain')); }
    finally { busy = false; sync(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer()?.dataset.open === 'true') close(); });
  count();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dpd-category-browser')) {
    customElements.define('dpd-category-browser', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = [...this.querySelectorAll('[data-category-tab]')];
        this.panels = [...this.querySelectorAll('[data-category-panel]')];
        this.querySelector('[data-category-tablist]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.panel);
          tab.addEventListener('click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.select(index);
          }, { signal });
          tab.addEventListener('keydown', event => {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            let next;
            if (event.key === 'ArrowRight') next = index + direction;
            if (event.key === 'ArrowLeft') next = index - direction;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        this.panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.params = new URLSearchParams({ 'filter.v.availability': '1', sort_by: 'created-descending' });
        });
        this.addEventListener('click', event => {
          const panel = event.target.closest('[data-category-panel]');
          if (!panel) return;
          const target = event.target.closest('button, a');
          if (!target) return;
          if (target.matches('[data-open-browser-filters]')) panel.querySelector('dialog').showModal();
          if (target.matches('[data-close-browser-filters]')) panel.querySelector('dialog').close();
          if (target.matches('[data-sort-option]')) {
            panel.querySelector('[data-sort-menu]').open = false;
            panel.querySelector('[data-browser-sort]').focus({ preventScroll: true });
            panel.params.set('sort_by', target.dataset.sortOption);
            panel.params.delete('page');
            this.load(panel);
          }
          if (target.matches('[data-browser-quick]')) {
            panel.params.set('sort_by', target.dataset.browserQuick);
            panel.params.delete('page');
            this.load(panel);
          }
          if (target.matches('[data-browser-clear]')) {
            event.preventDefault();
            panel.params = new URLSearchParams({ 'filter.v.availability': '1', sort_by: panel.params.get('sort_by') || 'created-descending' });
            panel.querySelector('dialog')?.close();
            this.load(panel);
          }
          if (target.matches('[data-browser-more]')) {
            if (panel.busy) { event.preventDefault(); return; }
            event.preventDefault();
            const next = new URL(target.href);
            panel.params.set('page', next.searchParams.get('page'));
            this.load(panel, true);
          }
          if (target.matches('[data-retry]')) this.load(panel, panel.retryAppend);
        }, { signal });
        document.addEventListener('click', event => {
          this.querySelectorAll('[data-sort-menu][open]').forEach(menu => {
            if (!menu.contains(event.target)) menu.open = false;
          });
        }, { signal });
        this.addEventListener('keydown', event => {
          const menu = event.target.closest('[data-sort-menu]');
          if (!menu) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            menu.open = false;
            menu.querySelector('summary').focus();
          }
          if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
            event.preventDefault();
            menu.open = true;
            const options = [...menu.querySelectorAll('[data-sort-option]')];
            let index = options.indexOf(document.activeElement);
            if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = options.length - 1;
            else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
            options[index]?.focus();
          }
        }, { signal });
        this.addEventListener('input', event => {
          const form = event.target.closest('[data-browser-form]');
          if (!form) return;
          const min = form.querySelector('[name="filter.v.price.gte"]');
          const max = form.querySelector('[name="filter.v.price.lte"]');
          if (min && max) min.setCustomValidity(min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber ? this.dataset.priceError : '');
        }, { signal });
        this.addEventListener('submit', event => {
          if (!event.target.matches('[data-browser-form]')) return;
          event.preventDefault();
          const panel = event.target.closest('[data-category-panel]');
          const sort = panel.params.get('sort_by') || 'created-descending';
          panel.params = new URLSearchParams(new FormData(event.target));
          [...panel.params].forEach(([key, value]) => { if (!value) panel.params.delete(key); });
          panel.params.set('sort_by', sort);
          panel.params.set('filter.v.availability', '1');
          panel.querySelector('dialog').close();
          this.load(panel);
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.closest('[data-block-id]').dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, { signal });
        this.select(Math.max(0, this.tabs.findIndex(tab => tab.classList.contains('is-selected'))));
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.classList.toggle('is-selected', i === index);
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach(panel => {
          panel.hidden = panel.id !== this.tabs[index].dataset.panel;
          if (!panel.hidden && !panel.loaded && !panel.busy) this.load(panel);
        });
      }
      async load(panel, append = false) {
        if (!panel.dataset.collection) return;
        panel.request?.abort();
        const request = new AbortController();
        panel.request = request;
        panel.busy = true;
        panel.retryAppend = append;
        panel.setAttribute('aria-busy', 'true');
        panel.querySelector('[data-retry]').hidden = true;
        const status = panel.querySelector('[data-browser-status]');
        status.textContent = this.dataset.loading;
        const more = panel.querySelector('[data-browser-more]');
        if (more) more.setAttribute('aria-disabled', 'true');
        const url = new URL(panel.dataset.collection, location.origin);
        url.search = panel.params.toString();
        url.searchParams.set('section_id', 'dpd-category-results');
        if (window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        const focused = document.activeElement;
        const focusSort = focused?.matches('[data-browser-sort]');
        const focusQuick = focused?.dataset.browserQuick;
        const focusFilter = focused?.matches('[data-open-browser-filters]');
        try {
          const response = await fetch(url, { signal: request.signal });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
          const content = documentResult.querySelector('[data-browser-result]');
          if (!content) throw new Error('Missing results');
          if (append) {
            const grid = panel.querySelector('[data-browser-grid]');
            const items = [...content.querySelectorAll('[data-browser-grid] > li')];
            grid.append(...items);
            panel.querySelector('[data-browser-pagination]').replaceWith(content.querySelector('[data-browser-pagination]'));
            items[0]?.querySelector('a')?.focus({ preventScroll: true });
          } else {
            panel.querySelector('[data-browser-content]').replaceChildren(content);
          }
          panel.loaded = true;
          panel.querySelectorAll('[data-browser-quick]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.browserQuick === panel.params.get('sort_by'))));
          const sort = panel.querySelector('[data-browser-sort]');
          panel.querySelectorAll('[data-sort-option]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sortOption === panel.params.get('sort_by'))));
          if (!append && !panel.hidden) {
            if (focusSort) sort?.focus({ preventScroll: true });
            else if (focusQuick) [...panel.querySelectorAll('[data-browser-quick]')].find(button => button.dataset.browserQuick === focusQuick)?.focus({ preventScroll: true });
            else if (focusFilter) panel.querySelector('[data-open-browser-filters]')?.focus({ preventScroll: true });
          }
          status.textContent = '';
        } catch (error) {
          if (error.name !== 'AbortError') {
            status.textContent = this.dataset.error;
            panel.querySelector('[data-retry]').hidden = false;
          }
        } finally {
          if (panel.request === request) {
            panel.busy = false;
            panel.setAttribute('aria-busy', 'false');
            panel.querySelector('[data-browser-more]')?.removeAttribute('aria-disabled');
          }
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.panels?.forEach(panel => panel.request?.abort());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-fragrance"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sage-featured-fragrance')) customElements.define('sage-featured-fragrance', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', event => {
        const choice = event.target.closest('[data-fragrance-variant]');
        if (!choice?.checked || choice.disabled) return;
        const price = this.querySelector('[data-fragrance-price]');
        if (price) price.textContent = choice.dataset.price;
        const compare = this.querySelector('[data-fragrance-compare]');
        if (compare) { compare.textContent = choice.dataset.compare; compare.hidden = !choice.dataset.compare; }
        const quantity = this.querySelector('[data-fragrance-quantity]');
        if (quantity) quantity.value = choice.dataset.min;
        const shipping = this.querySelector('[data-shipping-product]');
        if (shipping && shipping.dataset.country === 'IT') {
          const copy = shipping.querySelector('[data-shipping-copy]');
          if (copy) copy.textContent = Number(shipping.dataset.threshold || 0) > 0 && Number(choice.dataset.priceCents) >= Number(shipping.dataset.threshold) ? shipping.dataset.freeLabel : shipping.dataset.paidLabel;
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  (() => {
    if (window.dpdOverlayHeader) window.dpdOverlayHeader.destroy();
    let cleanup = () => {};
    const events = new AbortController();
    const mount = () => {
      cleanup();
      const header = document.querySelector('[data-home-overlay]');
      const firstSection = document.querySelector('#MainContent > .shopify-section');
      const hero = firstSection?.querySelector('promo-image-carousel');
      const wrapper = header?.closest('.shopify-section');
      if (!header || !hero || !wrapper) return;
      const listeners = new AbortController();
      let frame = 0;
      const update = () => {
        frame = 0;
        if (!header.isConnected || !hero.isConnected) return;
        const height = header.getBoundingClientRect().height;
        wrapper.style.setProperty('--dpd-overlay-height', height + 'px');
        wrapper.classList.add('dpd-overlay-header');
        const heroRect = hero.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        header.dataset.overHero = String(heroRect.height > height && heroRect.bottom > headerRect.bottom + 1 && heroRect.top <= headerRect.bottom);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const observer = new ResizeObserver(schedule);
      observer.observe(header);
      observer.observe(hero);
      const announcement = document.querySelector('.announcement-bar');
      if (announcement) observer.observe(announcement);
      window.addEventListener('scroll', schedule, { passive: true, signal: listeners.signal });
      window.addEventListener('resize', schedule, { passive: true, signal: listeners.signal });
      window.addEventListener('pageshow', schedule, { signal: listeners.signal });
      hero.addEventListener('load', schedule, { capture: true, signal: listeners.signal });
      update();
      cleanup = () => {
        listeners.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
        wrapper.classList.remove('dpd-overlay-header');
        wrapper.style.removeProperty('--dpd-overlay-height');
        delete header.dataset.overHero;
      };
    };
    for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
      document.addEventListener(event, mount, { signal: events.signal });
    }
    window.dpdOverlayHeader = { destroy() { cleanup(); events.abort(); } };
    mount();
  })();

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-predictive-search-input]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.discoveryTemplate = this.querySelector('[data-search-discovery-template]');
      this.form = this.querySelector('[data-search-form]');
      this.submit = this.querySelector('[data-search-submit]');
      this.endpoint = this.dataset.endpoint;
      this.searchUrl = this.dataset.searchUrl;
      this.recentKey = this.dataset.recentKey || 'dpd_recent_searches_v1';
      this.mobileSearch = this.closest('.mobile-search');
      this.abortController = null;
      this.timer = null;

      if (!this.input || !this.results || !this.form) return;

      this.input.addEventListener('focus', () => this.onFocus());
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { this.close(); if (this.mobileSearch) { this.mobileSearch.open = false; this.mobileSearch.querySelector('summary')?.focus(); } }
      });

      this.form.addEventListener('submit', (event) => {
        const term = this.input.value.trim();
        if (!term) {
          event.preventDefault();
          this.showDiscovery();
          return;
        }
        this.rememberSearch(term);
      });

      this.submit?.addEventListener('click', (event) => {
        if (this.input.value.trim()) return;
        event.preventDefault();
        this.input.focus();
        this.showDiscovery();
      });

      this.results.addEventListener('click', (event) => {
        if (event.target.closest('.predictive-results__all') || event.target.closest('.predictive-results__link')) {
          this.rememberSearch(this.input.value.trim());
        }
        if (event.target.closest('[data-clear-recent]')) {
          this.clearRecentSearches();
          this.showDiscovery();
        }
      });

      this.mobileSearch?.addEventListener('toggle', () => {
        if (!this.mobileSearch.open) {
          this.close();
          return;
        }
        const header = this.closest('[data-site-header]');
        header?.querySelectorAll('details[open]').forEach(details => {
          if (details !== this.mobileSearch) details.open = false;
        });
        this.syncPanelPosition();
        window.setTimeout(() => {
          if (!this.mobileSearch.open) return;
          this.input.focus({ preventScroll: true });
          if (this.input.value.trim().length < 1) this.showDiscovery();
          else this.fetchResults(this.input.value.trim());
        }, 0);
      });

      this.mobileSearch?.querySelector('[data-close-mobile-search]')?.addEventListener('click', () => {
        this.mobileSearch.open = false;
        this.close();
        this.mobileSearch.querySelector('summary')?.focus();
      });
      this.panelController?.abort();
      this.panelController = new AbortController();
      const signal = this.panelController.signal;
      window.addEventListener('resize', () => this.syncPanelPosition(), { signal });
      window.addEventListener('scroll', () => this.syncPanelPosition(), { signal, passive: true });
      document.addEventListener('click', (event) => {
        if (this.mobileSearch?.contains(event.target)) return;
        if (!this.contains(event.target)) {
          this.close();
          if (this.mobileSearch) this.mobileSearch.open = false;
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.panelController?.abort();
      this.abortPendingRequest();
      window.clearTimeout(this.timer);
    }

    syncPanelPosition() {
      if (!this.mobileSearch?.open) return;
      const bottom = this.closest('[data-site-header]')?.getBoundingClientRect().bottom;
      if (Number.isFinite(bottom)) this.mobileSearch.style.setProperty('--mobile-search-top', Math.max(0, bottom) + 'px');
    }

    onFocus() {
      if (this.input.value.trim().length < 1) this.showDiscovery();
    }

    onInput() {
      window.clearTimeout(this.timer);
      const term = this.input.value.trim();

      if (term.length < 1 || this.dataset.predictive !== 'true') {
        this.abortPendingRequest();
        this.showDiscovery();
        return;
      }

      this.timer = window.setTimeout(() => this.fetchResults(term), 180);
    }

    abortPendingRequest() {
      if (!this.abortController) return;
      this.abortController.abort();
      this.abortController = null;
    }

    getRecentSearches() {
      try {
        const stored = JSON.parse(localStorage.getItem(this.recentKey) || '[]');
        if (!Array.isArray(stored)) return [];
        return stored.filter((item) => typeof item === 'string' && item.trim()).slice(0, 5);
      } catch (error) {
        return [];
      }
    }

    setRecentSearches(items) {
      try {
        localStorage.setItem(this.recentKey, JSON.stringify(items.slice(0, 5)));
      } catch (error) {}
    }

    rememberSearch(rawTerm) {
      const term = rawTerm.trim();
      if (term.length < 2) return;
      const normalized = term.toLocaleLowerCase();
      const recent = this.getRecentSearches().filter((item) => item.toLocaleLowerCase() !== normalized);
      this.setRecentSearches([term, ...recent]);
    }

    clearRecentSearches() {
      try {
        localStorage.removeItem(this.recentKey);
      } catch (error) {}
    }

    recentSearchUrl(term) {
      const params = new URLSearchParams();
      params.set('q', term);
      params.set('type', 'product');
      params.set('options[prefix]', 'last');
      return this.searchUrl + '?' + params.toString();
    }

    hydrateRecentSearches() {
      const block = this.results.querySelector('[data-recent-searches]');
      const list = this.results.querySelector('[data-recent-searches-list]');
      if (!block || !list) return;

      const recent = this.getRecentSearches();
      block.hidden = recent.length === 0;
      list.replaceChildren();

      recent.forEach((term) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = this.recentSearchUrl(term);
        link.textContent = term;
        item.append(link);
        list.append(item);
      });
    }

    showDiscovery() {
      if (!this.discoveryTemplate) return;
      this.results.innerHTML = this.discoveryTemplate.innerHTML;
      this.hydrateRecentSearches();
      this.open();
    }

    async fetchResults(term) {
      this.abortPendingRequest();
      const controller = new AbortController();
      this.abortController = controller;
      const requestedTerm = term;
      const url = this.endpoint + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,body,vendor,product_type,variants.title&section_id=predictive-search';

      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error(String(response.status));
        const responseText = await response.text();
        if (this.input.value.trim() !== requestedTerm) return;

        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const section = parsed.querySelector('#shopify-section-predictive-search');
        if (!section) return;

        this.results.innerHTML = section.innerHTML;
        this.open();
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.input.value.trim().length < 1) this.showDiscovery();
      } finally {
        if (this.abortController === controller) this.abortController = null;
      }
    }

    open() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.abortPendingRequest();
      window.clearTimeout(this.timer);
      this.results.hidden = true;
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('details').removeAttribute('open'));
  });

  document.querySelectorAll('.mobile-navigation').forEach((details) => {
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        details.removeAttribute('open');
        details.querySelector('summary')?.focus();
      }
    });
  });

  document.querySelectorAll('.desktop-navigation__details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.desktop-navigation__details[open]').forEach((openDetails) => {
        if (openDetails !== details) openDetails.removeAttribute('open');
      });
    });
  });

  document.querySelectorAll('.header-account-menu').forEach((details) => {
    details.querySelectorAll('[data-account-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (window.Shopify?.designMode) {
          event.preventDefault();
          window.open(link.href, '_blank', 'noopener,noreferrer');
        }
        details.removeAttribute('open');
      });
    });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        details.removeAttribute('open');
        details.querySelector('summary')?.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('sage-catalog')) {
    customElements.define('sage-catalog', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        if (dialog) {
          const open = this.querySelector('[data-open-filters]');
          const close = this.querySelector('[data-close-filters]');
          const desktop = matchMedia('(min-width: 990px)');
          const sync = () => {
            if (dialog.open) dialog.close();
            open.hidden = desktop.matches;
            close.hidden = desktop.matches;
            if (desktop.matches) dialog.show();
          };
          sync();
          desktop.addEventListener('change', sync, { signal });
          open.addEventListener('click', () => dialog.showModal(), { signal });
          close.addEventListener('click', () => dialog.close(), { signal });
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, { signal });
        }
        this.querySelectorAll('[data-price-range]').forEach(range => {
          const min = range.querySelector('[data-price-min]');
          const max = range.querySelector('[data-price-max]');
          const validate = () => min.setCustomValidity(min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber ? this.dataset.priceError : '');
          min.addEventListener('input', validate, { signal });
          max.addEventListener('input', validate, { signal });
          validate();
        });
        this.querySelectorAll('[data-brand-search]').forEach(input => {
          const list = input.closest('.catalog-filter')?.querySelector('[data-brand-list]');
          if (!list) return;
          const items = [...list.querySelectorAll('[data-filter-value]')];
          input.addEventListener('input', () => {
            const query = input.value.trim().toLocaleLowerCase();
            items.forEach(item => {
              item.hidden = query !== '' && !item.dataset.filterValue.includes(query);
            });
          }, { signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sage-slideshow')) {
    customElements.define('sage-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.index = 0;
        this.timer = null;
        if (this.slides.length < 2) return;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.editor = Boolean(window.Shopify?.designMode);
        this.autoplay = this.dataset.autoplay === 'true';
        this.paused = !this.autoplay || this.reducedMotion.matches || this.editor;
        this.hovered = false;
        this.visible = true;
        this.editingBlock = false;
        this.toggle = this.querySelector('[data-toggle]');
        this.querySelector('[data-controls]').hidden = false;
        this.toggle.hidden = !this.autoplay;
        this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1, true), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), { signal }));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', (event) => {
          if (!this.contains(event.relatedTarget)) { this.paused = true; this.sync(); }
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.target.closest('a, input, textarea, select')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, { signal });
        const track = this.querySelector('.sage-slideshow__track');
        track.addEventListener('pointerdown', (event) => {
          this.gesture = event.isPrimary && event.pointerType !== 'mouse' ? { x: event.clientX, y: event.clientY } : null;
        }, { signal });
        track.addEventListener('pointerup', (event) => {
          if (!this.gesture) return;
          const x = event.clientX - this.gesture.x;
          const y = event.clientY - this.gesture.y;
          this.gesture = null;
          if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) {
            this.suppressClickUntil = performance.now() + 500;
            this.go(this.index + (x < 0 ? 1 : -1), true);
          }
        }, { signal });
        track.addEventListener('pointercancel', () => { this.gesture = null; }, { signal });
        track.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressClickUntil || 0)) event.preventDefault();
        }, { signal, capture: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => {
          if (this.reducedMotion.matches) this.paused = true;
          this.sync();
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editingBlock = true; this.go(index, true); }
        }, { signal });
        this.addEventListener('shopify:block:deselect', () => { this.editingBlock = false; this.schedule(); }, { signal });
        this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.go(0);
      }
      go(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) this.paused = true;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (manual) this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
        this.sync();
      }
      sync() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-play-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || !this.visible || document.hidden || this.editingBlock || this.editor) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Math.max(4000, Number(this.dataset.interval) || 6000));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('sage-product')) customElements.define('sage-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController(); const { signal } = this.controller;
      const panels = [...this.querySelectorAll('[data-media-id]')];
      const thumbs = [...this.querySelectorAll('[data-media-target]')];
      const showMedia = id => {
        if (!panels.some(p => p.dataset.mediaId === id)) return;
        panels.forEach(p => { p.hidden = p.dataset.mediaId !== id; if (p.hidden) p.querySelectorAll('video').forEach(v => v.pause()); });
        thumbs.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.mediaTarget === id)));
      };
      showMedia(this.dataset.selectedMedia || panels[0]?.dataset.mediaId);
      const thumbnailBar = this.querySelector('[data-thumbnails]'); if (thumbnailBar) thumbnailBar.hidden = false;
      thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.mediaTarget), { signal }));
      const reviewsTrigger = this.querySelector('[data-scroll-reviews]');
      const reviewsTarget = this.querySelector('.pdp-reviews');
      const scrollToReviews = () => reviewsTarget?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      reviewsTrigger?.addEventListener('click', scrollToReviews, { signal });
      reviewsTrigger?.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); scrollToReviews(); }
      }, { signal });

      const sticky = this.querySelector('[data-sticky-bar]');
      const purchase = this.querySelector('.pdp-purchase');
      let purchaseVisible = true;
      const syncSticky = () => {
        if (!sticky) return;
        const visible = window.matchMedia('(max-width: 749px)').matches && window.scrollY > 220 && !purchaseVisible;
        sticky.dataset.visible = String(visible);
        sticky.setAttribute('aria-hidden', String(!visible));
        if (visible) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      if (sticky && purchase && 'IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver(entries => {
          purchaseVisible = entries[0]?.isIntersecting ?? true;
          syncSticky();
        }, { threshold: 0.2 });
        this.stickyObserver.observe(purchase);
      }
      window.addEventListener('scroll', syncSticky, { passive: true, signal });
      window.addEventListener('resize', syncSticky, { passive: true, signal });
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => this.querySelector('[data-add]')?.click(), { signal });
      syncSticky();

      const select = this.querySelector('[data-variant]');
      const picker = this.querySelector('[data-variant-pills]');
      const choices = [...this.querySelectorAll('[data-variant-choice]')];
      if (select && picker && choices.length) {
        select.hidden = true;
        this.querySelector('label[for="' + select.id + '"]')?.setAttribute('hidden', '');
        picker.hidden = false;
        choices.forEach(choice => {
          choice.checked = choice.value === select.value;
          choice.addEventListener('change', () => {
            if (!choice.checked) return;
            select.value = choice.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }, { signal });
        });
      }
      select?.addEventListener('change', () => {
        const v = select.options[select.selectedIndex]; if (!v) return;
        choices.forEach(choice => { choice.checked = choice.value === v.value; });
        this.querySelector('[data-price]').textContent = v.dataset.price;
        const compare = this.querySelector('[data-compare]'); compare.textContent = v.dataset.compare; compare.hidden = !v.dataset.compare;
        const saleBadge = this.querySelector('[data-sale-badge]');
        if (saleBadge) { saleBadge.textContent = '-' + v.dataset.discount + '%'; saleBadge.hidden = Number(v.dataset.discount || 0) <= 0; }
        const stickyPrice = this.querySelector('[data-sticky-price]'); if (stickyPrice) stickyPrice.textContent = v.dataset.price;
        const stickyCompare = this.querySelector('[data-sticky-compare]'); if (stickyCompare) { stickyCompare.textContent = v.dataset.compare; stickyCompare.hidden = !v.dataset.compare; }
        const stickySale = this.querySelector('[data-sticky-sale]'); if (stickySale) { stickySale.textContent = '-' + v.dataset.discount + '%'; stickySale.hidden = Number(v.dataset.discount || 0) <= 0; }
        const unit = this.querySelector('[data-unit]'); unit.textContent = v.dataset.unit; unit.hidden = !v.dataset.unit;
        const available = v.dataset.available === 'true';
        this.querySelector('[data-stock]').textContent = available ? this.dataset.availableLabel : this.dataset.unavailableLabel;
        const button = this.querySelector('[data-add]'); if (button) { button.disabled = !available; button.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel; }
        const stickyButton = this.querySelector('[data-sticky-add]'); if (stickyButton) { stickyButton.disabled = !available; stickyButton.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel; }
        const qty = this.querySelector('[data-quantity]'); if (qty) { qty.min = v.dataset.min; qty.step = v.dataset.step; qty.value = v.dataset.min; if (v.dataset.max) qty.max = v.dataset.max; else qty.removeAttribute('max'); }
        showMedia(v.dataset.media);
        const shipping = this.querySelector('[data-shipping-product]');
        if (shipping && shipping.dataset.country === 'IT') {
          const copy = shipping.querySelector('[data-shipping-copy]');
          const threshold = Number(shipping.dataset.threshold || 0);
          const priceCents = Number(v.dataset.priceCents || 0);
          if (copy) copy.textContent = threshold > 0 && priceCents >= threshold ? shipping.dataset.freeLabel : shipping.dataset.paidLabel;
        }
        const url = new URL(location.href); url.searchParams.set('variant', v.value); history.replaceState({}, '', url);
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.stickyObserver?.disconnect(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('sage-search-page')) {
    customElements.define('sage-search-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        if (dialog) {
          const open = this.querySelector('[data-open-filters]');
          const close = this.querySelector('[data-close-filters]');
          const desktop = matchMedia('(min-width: 990px)');
          const sync = () => {
            if (dialog.open) dialog.close();
            open.hidden = desktop.matches;
            close.hidden = desktop.matches;
            if (desktop.matches) dialog.show();
          };
          sync();
          desktop.addEventListener('change', sync, { signal });
          open.addEventListener('click', () => dialog.showModal(), { signal });
          close.addEventListener('click', () => dialog.close(), { signal });
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, { signal });
        }
        this.querySelectorAll('[data-price-range]').forEach(range => {
          const min = range.querySelector('[data-price-min]');
          const max = range.querySelector('[data-price-max]');
          const validate = () => min.setCustomValidity(min.value !== '' && max.value !== '' && min.valueAsNumber > max.valueAsNumber ? this.dataset.priceError : '');
          min.addEventListener('input', validate, { signal });
          max.addEventListener('input', validate, { signal });
          validate();
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sage-recommendations')) customElements.define('sage-recommendations', class extends HTMLElement {
    async connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = doc.querySelector('sage-recommendations');
        if (content?.querySelector('.sage-product-card') && this.isConnected) {
          this.innerHTML = content.innerHTML; this.hidden = false;
        }
      } catch (_) { /* Keep the collection fallback when recommendations are unavailable. */ }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["professional-hair-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('professional-hair-landing')) {
    customElements.define('professional-hair-landing', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-pro-tab]')];
        this.panels = [...this.querySelectorAll('[data-pro-panel]')];
        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.querySelector('[data-pro-tabs]').setAttribute('role','tablist');
        this.tabs.forEach((tab,index) => {
          tab.setAttribute('role','tab');
          tab.setAttribute('aria-controls',this.panels[index].id);
          this.panels[index].setAttribute('role','tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click',event => { if(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); this.select(index); },options);
          tab.addEventListener('keydown',event => {
            let next = index;
            if(event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if(event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if(event.key === 'Home') next = 0;
            else if(event.key === 'End') next = this.tabs.length - 1;
            else if(event.key !== ' ' && event.key !== 'Enter') return;
            event.preventDefault(); this.select(next); this.tabs[next].focus();
          },options);
        });
        this.addEventListener('shopify:block:select',event => { const index=this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId); if(index >= 0) this.select(index); },options);
        const initial=this.panels.findIndex(panel => '#' + panel.id === window.location.hash);
        this.select(initial < 0 ? 0 : initial);
      }
      select(index) {
        this.tabs.forEach((tab,i) => { tab.setAttribute('aria-selected',String(i === index)); tab.tabIndex = i === index ? 0 : -1; this.panels[i].hidden = i !== index; });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-image-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-image-carousel')) {
    customElements.define('promo-image-carousel', class extends HTMLElement {
      connectedCallback() {
        this.headerObserver?.disconnect();
        const header = document.querySelector('[data-site-header]');
        if (header) {
          const updateHeaderHeight = () => this.style.setProperty('--promo-header-height', header.getBoundingClientRect().height + 'px');
          this.headerObserver = new ResizeObserver(updateHeaderHeight);
          this.headerObserver.observe(header);
          updateHeaderHeight();
        }
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.timer = null;
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.schedule());

        let startX = null;
        this.addEventListener('touchstart', event => {
          startX = event.touches?.[0]?.clientX ?? null;
        }, { passive: true });

        this.addEventListener('touchend', event => {
          if (startX === null) return;
          const endX = event.changedTouches?.[0]?.clientX ?? startX;
          const delta = endX - startX;
          startX = null;
          if (Math.abs(delta) > 45) this.go(this.index + (delta < 0 ? 1 : -1), true);
        }, { passive: true });

        document.addEventListener('visibilitychange', () => this.schedule());
        this.schedule();
      }

      go(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });

        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.stop();
        if (!manual) this.schedule();
        else this.timer = setTimeout(() => this.schedule(), this.interval);
      }

      stop() {
        clearTimeout(this.timer);
      }

      schedule() {
        this.stop();
        if (!this.autoplay || this.reducedMotion || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }

      disconnectedCallback() {
        this.headerObserver?.disconnect();
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
